import { LockOutlined } from "@ant-design/icons";
import * as React from "react";
import { ZDisplayId } from "src/types/ZDisplayId";
import { ZUid } from "src/types/zUid";

/**
 * Заголовок узла дерева.
 *
 * Единственное место, где он собирается: в v1 такая функция лежала внутри
 * фабрики узлов и не экспортировалась, поэтому v2 её скопировала. Здесь она
 * общая для всех четырёх вариантов, различается только подпись для пустого
 * имени.
 */
export const renderNodeTitle = (params: {
  name: string;
  id: ZUid;
  displayId?: ZDisplayId | null;
  disabled: boolean;
  placeholder: string;
}): React.ReactNode => {
  const { name, id, displayId, disabled, placeholder } = params;
  if (!name) return <i>{placeholder}</i>;
  const text = `${name} (${displayId ?? id})`;
  if (!disabled) return text;
  return (
    <span style={{ color: "#999" }}>
      {text} <LockOutlined />
    </span>
  );
};
